import { Pressable, StyleSheet } from "react-native";
import { useAtom } from "jotai";
import { currentLang } from "../../../../atoms/i18n";
import { useTheme } from "../../../../hooks/use-theme";
import { useMemo } from "react";
import { AVAILABLE_LANGUAGE } from "../../../../i18n/config";
import { BodySmallText } from "../../../../components/FormattedText";
import Icon from "../../../../components/Icon";
import { useItemsDropdown } from "../../../../components/Dropdown";
import { useDropdown } from "../../../../hooks/use-dropdown";
import HStack from "../../../../ui_atoms/HStack";

type AvailableLanguage = (typeof AVAILABLE_LANGUAGE)[number];
const LANGUAGE_NAME: Record<AvailableLanguage, string> = {
    fr: "Français",
    de: "Deutsch",
};

export const LanguageSelector = () => {
    const [lang, setLang] = useAtom(currentLang);
    const styles = useStyles();

    const currentLanguageName = LANGUAGE_NAME[lang] || LANGUAGE_NAME["fr"];
    const dropdownItems = useMemo(() => {
        return AVAILABLE_LANGUAGE.map((language) => {
            const isSelected = lang === language;
            const languageName = LANGUAGE_NAME[language];
            return {
                label: languageName,
                selected: isSelected,
                onClick: () => setLang(language),
            };
        });
    }, [lang, setLang]);

    const dropdownComponent = useItemsDropdown({
        items: dropdownItems,
    });

    const dropdownProps = useDropdown({
        component: dropdownComponent,
    });

    if (AVAILABLE_LANGUAGE.length < 2) {
        return null;
    }

    return (
        <Pressable {...dropdownProps}>
            <HStack v={1 / 4} h={1 / 3} gap={1 / 3} style={styles.selectedButton}>
                <Icon name="globe" size={16} />
                <BodySmallText numberOfLines={1}>{currentLanguageName}</BodySmallText>
            </HStack>
        </Pressable>
    );
};

const useStyles = () => {
    const { colors } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                selectedButton: {
                    backgroundColor: colors.background,
                    borderRadius: 20,
                    minWidth: 100,
                },
            }),
        [colors],
    );
};
